/* unplugin-vue-components disabled */import { render } from "./xLayoutContent.vue?vue&type=template&id=62abf664"
import script from "./xLayoutContent.vue?vue&type=script&lang=jsx"
export * from "./xLayoutContent.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__